module.exports = __webpack_public_path__ + "img/symbol_5.ea83e30d.png";